// extracted by mini-css-extract-plugin
module.exports = {"contactWrapper":"Policy_contactWrapper__2x1Eg","internalText":"Policy_internalText__1_cOX"};